var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6044 19.4364C1.45988 19.4362 1.31699 19.4059 1.18482 19.3474C1.05266 19.2889 0.934099 19.2036 0.836692 19.0968C0.737524 18.991 0.661851 18.8654 0.614638 18.7282C0.567425 18.5911 0.549737 18.4455 0.562733 18.301L0.817942 15.4948L12.6075 3.70935L16.2919 7.39268L4.50544 19.1771L1.69919 19.4323C1.66768 19.4352 1.63605 19.4366 1.6044 19.4364ZM17.0273 6.65622L13.344 2.97289L15.5534 0.763515C15.6501 0.666664 15.765 0.589832 15.8914 0.537411C16.0179 0.48499 16.1534 0.458008 16.2903 0.458008C16.4272 0.458008 16.5628 0.48499 16.6892 0.537411C16.8157 0.589832 16.9306 0.666664 17.0273 0.763515L19.2367 2.97289C19.3335 3.06963 19.4104 3.18452 19.4628 3.31097C19.5152 3.43743 19.5422 3.57298 19.5422 3.70987C19.5422 3.84676 19.5152 3.98231 19.4628 4.10877C19.4104 4.23522 19.3335 4.35011 19.2367 4.44685L17.0284 6.65518L17.0273 6.65622Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.3a1dc8b026a71c518db53858c3a5ddb3.svg";
export { ForwardRef as ReactComponent };